import styled from 'styled-components';

export const QcLevelLineLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr auto;
    gap: 1rem;
    align-items: end;
`;

export const QcLevelRangeInputs = styled.div`
    display: contents;
`;

export const QcLevelTargetValues = styled.div`
    grid-column: 2 / span 2;
`;
